// @flow
import * as React from 'react';
import { Box } from 'grommet';
import { FormattedMessage } from 'react-intl';
import { Route, Match, RouterHistory } from 'react-router-dom';
import { withRouter } from 'react-router';
import CableIcon from 'esm-web-pro/components/layout/sidePanel/icons/CableIcon';
import UpperContainer from 'esm-web-pro/components/layout/sidePanel/UpperContainer';
import HorizontalLine from 'esm-web-pro/components/layout/HorizontalLine';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import CableAttributes from 'esm-web-pro/containers/pages/network/objects/CableAttributes';
import CableActions from 'esm-web-pro/containers/pages/network/objects/cable/CableActions';
import CableContent from 'esm-web-pro/containers/pages/network/objects/CableContent';
import ModelAttributes from 'esm-web-pro/containers/pages/network/ModelAttributes';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import type { Map } from 'esm-web-pro/containers/map/types';
import type { Cable } from 'esm-web-pro/types/networks';
import BottomContainer from 'esm-web-pro/components/layout/sidePanel/BottomContainer';
import NavigateBackButton from 'esm-web-pro/components/maps/NavigateBackButton';

type Props = {
    panelId: String,
    cable: Cable,
    editor: React.Node,
    map: Map,
    mapEditor: BaseEditor,
    highlightFiber?: Function,
    highlightCable?: Function,
    handleView: Function,
    clicked?: string,
    setClicked?: Function,
    updateObject: Function,

    history: RouterHistory,
    match: Match,
};

const CablePanel = (props: Props) => {
    const {
        cable, editor, map, mapEditor, highlightFiber, highlightCable, handleView, clicked, setClicked, updateObject,
        history, match, panelId,
    } = props;

    const navigateBack = () => {
        history.push(match.url.split('/layer')[0]);
    };

    return (
        <SidePane
            id={panelId}
            openInitially
            closeAllOpened
            title={cable.ref}
            titleLabel={cable.patch ? (
                <FormattedMessage id="patch-cable-panel-title" defaultMessage="Patch" />
            ) : (
                <FormattedMessage id="cable-panel-title" defaultMessage="Cable" />
            )}
            titleIcon={<CableIcon />}
            titleOnView={() => {
                handleView();
                setClicked(null);
            }}
            actions={<NavigateBackButton panelId={panelId} />}
        >
            <Box height="100%" justify="between">
                <Box flex>
                    <UpperContainer>
                        <HorizontalLine color="grey" />
                        <CableAttributes cable={cable} url={match.url} onView={handleView} />
                        <HorizontalLine color="grey" />
                        <Box direction="row">
                            <CableActions
                                map={map}
                                cable={cable}
                                navigateBack={navigateBack}
                                updateObject={updateObject}
                                mapEditor={mapEditor}
                                onView={handleView}
                                highlightCable={highlightCable}
                                editor={editor}
                            />
                        </Box>
                        <HorizontalLine color="grey" />
                    </UpperContainer>
                    <BottomContainer>
                        <CableContent
                            cable={cable}
                            editor={mapEditor}
                            map={map}
                            highlightFiber={highlightFiber}
                            highlightCable={highlightCable}
                            clicked={clicked}
                            setClicked={setClicked}
                        />
                    </BottomContainer>
                </Box>
                <Route
                    path={`${match.path}/model/:modelCode`.replace('//', '/')}
                    render={({ match: _match }) => (
                        <ModelAttributes url={_match.url} />
                    )}
                />
            </Box>
        </SidePane>
    );
};

CablePanel.defaultProps = {
    highlightFiber: undefined,
    highlightCable: undefined,
    clicked: undefined,
    setClicked: undefined,
};

export default withRouter(CablePanel);
